import React, {Fragment} from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import { styled } from "@mui/system";
import styles from "./table.module.css";
import CustomTooltip from "../../../utils/CustomTooltip";
const StyledTableCell = styled(TableCell)(({ theme }) => ({
    "&.MuiTableCell-head": {
        fontFamily: "Unilever Shilling",
        backgroundColor: "#2036C7",
        color: "#fff",
        textAlign: "center",
        padding: "5px",
        fontSize: "12px",
        fontWeight: 400,
        border: "1px solid #EAECF0",
    },
    "&.MuiTableCell-body": {
        fontFamily: "Unilever Shilling",
        fontSize: 12,
        fontWeight: 400,
        padding: "5px",
        color: "#2B2B2B",
        border: "1px solid #EAECF0",
    },
}));

const StyledTableRow = styled(TableRow)({});
const ShareDeprioritizedCBU = ({data})=>{
    const normalCloumn = data?.length > 0 ? Object.keys(data[0])?.filter(itm=> !['Alerts', 'Left Over Plan Qty']?.includes(itm)) : [];//get first lebel column
    const alertsColumns = data?.length > 0 ? Object.keys(data[0]?.Alerts[0]) : []; //get Alerts column
    const columns = [...normalCloumn, ...alertsColumns]; //combine both column for display

    const containerStyle = {
        maxHeight: data?.length > 5 ? "200px" : "auto",
        overflowY: data?.length > 5 ? "auto" : "unset",
    };
    return(
        <Fragment>
            <TableContainer className={styles.table} sx={containerStyle}>
                <Table size="small" stickyHeader>
                    <TableHead>
                        <TableRow>
                            {columns?.map((col, index) => {
                                // if(['CBU code','Week Plan', 'Alert CBU', 'Alert CBU Description', 'Deprioritized Qty', 'Shared Recommendation', 'Recovered qty']?.includes(col)){
                                //     return (
                                //         <StyledTableCell key={index}>
                                //             <div
                                //                 className={styles.ellipsisTextColumnHeader}
                                //                 style={{ maxWidth: "100px" }}
                                //             >
                                //                 <CustomTooltip title={col}>
                                //                     {col}
                                //                 </CustomTooltip>
                                //             </div>
                                //         </StyledTableCell>
                                //     )
                                // } else {
                                    return(
                                        <StyledTableCell key={index}
                                            align={"center"}
                                        >
                                            {col}
                                        </StyledTableCell>
                                    )
                                // }
                            })}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data?.length > 0 ? (
                            data?.map((itm, rowIndex) => (
                                itm?.Alerts?.map((alert, alertIndex)=>(
                                    <StyledTableRow key={`${rowIndex}-${alertIndex}`}>
                                        {alertIndex === 0 && (
                                            normalCloumn?.map((ncol)=>{
                                                if(['CBU Desc', 'Line']?.includes(ncol)){
                                                    return(
                                                        <StyledTableCell 
                                                            rowSpan={itm?.Alerts?.length}
                                                            align={typeof itm?.[ncol] === 'number' ? "right" :"center"}
                                                            className={styles.ellipsisText}
                                                        >
                                                            <CustomTooltip title={itm?.[ncol]}>
                                                                <span>{itm?.[ncol]}</span>
                                                            </CustomTooltip>
                                                        </StyledTableCell>
                                                    )
                                                }else{
                                                    return(
                                                        <StyledTableCell 
                                                            rowSpan={itm?.Alerts?.length}
                                                            align={typeof itm?.[ncol] === 'number' ? "right" :"center"}
                                                            style={{
                                                                maxWidth : "80px",
                                                                width: 'auto',
                                                                // color: "var(--primary-unilever-color)",
                                                                // fontWeight:  500
                                                            }}
                                                        >
                                                            {itm?.[ncol]}
                                                        </StyledTableCell>
                                                    )
                                                }
                                            })
                                        )}
                                        {alertsColumns?.map((acol)=>{
                                            if(['CBU Desc', 'Alert CBU Description', 'Alert ID']?.includes(acol)){
                                                return(<StyledTableCell 
                                                    align={typeof alert?.[acol] === 'number' ? "right" :"center"}
                                                    className={styles.ellipsisText}
                                                >
                                                    <CustomTooltip title={alert?.[acol]}>
                                                        <span>{alert?.[acol]}</span>
                                                    </CustomTooltip>
                                                </StyledTableCell>)
                                            } else {
                                                return(<StyledTableCell 
                                                    align={typeof alert?.[acol] === 'number' ? "right" :"center"}
                                                    style={{
                                                        maxWidth : "80px",
                                                        width: 'auto',
                                                        // color: "var(--primary-unilever-color)",
                                                        // fontWeight:  500
                                                    }}
                                                >
                                                    {typeof alert?.[acol] === 'number' ? alert?.[acol]?.toFixed(1): alert?.[acol]}
                                                </StyledTableCell>)
                                            }
                                        })}
                                    </StyledTableRow>
                                ))
                            ))
                            ): (
                            <StyledTableRow>
                                <StyledTableCell colSpan={columns.length || 1} sx={{ whiteSpace: "nowrap" }}>
                                    Data not available...
                                </StyledTableCell>
                            </StyledTableRow> ) 
                        }
                    </TableBody>
                </Table>
            </TableContainer >
        </Fragment>
    );
};
export default ShareDeprioritizedCBU;